import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets the window scroll to (0,0) on every route change.
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Use instant scroll (not smooth) so the transition feels crisp.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search]);
  return null;
}
